import { useHandleSignInCallback, useLogto } from '@logto/react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { AuthStoreHook } from "../login/hooks"
import { baseUrl } from 'constant';

const Callback = () => {
    const { StoreAuthUser } = AuthStoreHook()
    const redirect = useNavigate()
    const { getIdToken } = useLogto();
    const { isLoading } = useHandleSignInCallback(() => {
        const readToken = async () => {
            try {
                const AuthToken = (await getIdToken())
                const res = await axios.get(`${baseUrl}auth/refresh-token`, {
                    headers: {
                        AuthToken
                    }
                })

                if (res.status === 200) {
                    StoreAuthUser(res.data.data)
                    redirect('/dashboard', { state: { breadcumbName: 'dashboard' } })
                }
            } catch (error) {
                redirect('/')
            }
        }

        readToken()
    });

    // When it's working in progress
    if (isLoading) {
        return <div>Redirecting...</div>;
    }

    return null;
};

export default Callback;